import { useAsyncRetry } from 'react-use-v13';
import apiFetch from '@scale/frontend-lib/api-fetch';
import { QMShowProjectConfigResponse } from '@scale/shared/qm/qmRequestTypes';
import { useState, useCallback, useEffect } from 'react';

async function fetchQuery(projectId: string | undefined) {
  if (projectId) {
    return await apiFetch<QMShowProjectConfigResponse>(
      null,
      `corp-api/lookup/${projectId}/config?project=${projectId}&type=project`,
      {
        method: 'GET',
      },
    );
  }
}

export default function useQMProjectConfig(projectId: string | undefined) {
  const [loading, setLoading] = useState<boolean>(true);
  const [value, setValue] = useState<any>(undefined);
  const state = useAsyncRetry(async () => fetchQuery(projectId), [projectId]);
  useEffect(() => {
    if (!state.loading) {
      setLoading(false);
    }
  }, [state.loading]);
  useEffect(() => {
    if (state.value) {
      setValue(state.value);
    }
  }, [state.value]);
  const handleBackgroundRetry = useCallback(() => {
    state.retry();
  }, [state]);

  return {
    loadingConfig: loading,
    errorConfig: state.error,
    projectConfig: value,
    retryConfig: handleBackgroundRetry,
  };
}
